import { render, staticRenderFns } from "./add_by_zian.vue?vue&type=template&id=27ee9b45&scoped=true&"
import script from "./add_by_zian.vue?vue&type=script&lang=js&"
export * from "./add_by_zian.vue?vue&type=script&lang=js&"
import style0 from "./add_by_zian.vue?vue&type=style&index=0&id=27ee9b45&prod&lang=css&"
import style1 from "./add_by_zian.vue?vue&type=style&index=1&id=27ee9b45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee9b45",
  null
  
)

export default component.exports